/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createInternalErrorResponseFromDiscriminatorValue, createListCustomerUserImportJobsResponseFromDiscriminatorValue, type InternalErrorResponse, type ListCustomerUserImportJobsResponse } from '../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/users/customers/import/jobs
 */
export interface JobsRequestBuilder extends BaseRequestBuilder<JobsRequestBuilder> {
    /**
     * Lists the organization's recent customer-user import jobs, newest first — the queued and running ones alongside those that finished within the retention window. Each entry is a summary: queued and expiry times, progress so far, and the outcome counts once the import completes. The per-row report itself is never included here; fetch it by tracking id from the import progress endpoint while reportAvailable is true. Jobs and their reports are deleted about a day after being queued, at which point they leave this list. The organization comes from the caller's token claims.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ListCustomerUserImportJobsResponse>}
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ListCustomerUserImportJobsResponse | undefined>;
    /**
     * Lists the organization's recent customer-user import jobs, newest first — the queued and running ones alongside those that finished within the retention window. Each entry is a summary: queued and expiry times, progress so far, and the outcome counts once the import completes. The per-row report itself is never included here; fetch it by tracking id from the import progress endpoint while reportAvailable is true. Jobs and their reports are deleted about a day after being queued, at which point they leave this list. The organization comes from the caller's token claims.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const JobsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/users/customers/import/jobs";
/**
 * Metadata for all the requests in the request builder.
 */
export const JobsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: JobsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createListCustomerUserImportJobsResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
